import { render, staticRenderFns } from "./HeaderThemes.vue?vue&type=template&id=986ffe8a&scoped=true&"
import script from "./HeaderThemes.vue?vue&type=script&lang=js&"
export * from "./HeaderThemes.vue?vue&type=script&lang=js&"
import style0 from "./HeaderThemes.vue?vue&type=style&index=0&id=986ffe8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986ffe8a",
  null
  
)

export default component.exports